import React from 'react';
import './Cgwanoc.css'; // Create a CSS file for CGWA NOC specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_cgwa_noc_banner from '../../assets/images/cgwa-1.jpg'; // Replace with the actual image for CGWA NOC
import { FaWater, FaGavel, FaShieldAlt, FaCertificate, FaClipboardList, FaPaperPlane } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function CGWANOC() {
  const cgwaNocBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Sustainable Water Usage',
      text: 'Ensure sustainable and responsible usage of groundwater resources for your operations.',
    },
    {
      icon: <FaCertificate />,
      title: 'Legal Compliance',
      text: 'Comply with the regulations set by the Central Ground Water Authority for water extraction.',
    },
    {
      icon: <FaWater />,
      title: 'Water Conservation',
      text: 'Implement water conservation measures through proper licensing and monitoring.',
    },
    {
      icon: <FaGavel />,
      title: 'Avoid Penalties',
      text: 'Obtain CGWA NOC to avoid penalties for unauthorized groundwater extraction.',
    },
  ];

  const steps = [
    {
      icon: <FaClipboardList />,
      title: 'Initial Consultation',
      description: 'Discuss the water extraction requirements and CGWA NOC process.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Documentation Preparation',
      description: 'Prepare the necessary documents and water usage details for the NOC application.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Groundwater Assessment',
      description: 'Conduct an assessment to ensure your water usage meets CGWA standards.',
    },
    {
      icon: <FaCertificate />,
      title: 'Application Submission',
      description: 'Submit the NOC application along with the required documents and wait for approval.',
    },
    {
      icon: <FaWater />,
      title: 'CGWA NOC Issuance',
      description: 'Receive the CGWA NOC to authorize groundwater extraction and ensure compliance.',
    },
  ];

  const acts = [
    'The Environment Protection Act, 1986',
    'Central Ground Water Authority (CGWA) Regulations',
    'National Water Policy',
  ];

  const explanation =
    'The CGWA regulates groundwater extraction to ensure the sustainable use of water resources across the country. Compliance with CGWA regulations is crucial for industries that rely on groundwater for their operations.';

  const checklistItems = [
    { name: 'Groundwater Extraction Details', description: 'Provide details of the water extraction method and volume.' },
    { name: 'Water Usage Report', description: 'Include a report of current water usage and conservation measures.' },
    { name: 'Environmental Impact Assessment', description: 'Submit an environmental impact assessment of water extraction activities.' },
    { name: 'No Objection Certificate (NOC)', description: 'Attach a copy of the NOC from the local water authority if applicable.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Central Ground Water Authority (CGWA) NOC"
        subheading="Ensure compliance with groundwater extraction regulations by obtaining the necessary NOC from CGWA."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/cgwanoc' }}
        backgroundImage={img_cgwa_noc_banner} // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is CGWA NOC?"
        description="The Central Ground Water Authority (CGWA) No Objection Certificate (NOC) is required for industries and organizations that extract groundwater. This NOC ensures sustainable groundwater extraction and compliance with the relevant regulations."
        image={img_cgwa_noc_banner} // Image for CGWA NOC process
        altText="CGWA NOC Process"
      />

      <ServicesBenefitsSection
        title="Why You Need CGWA NOC"
        description="Discover the key benefits of obtaining the CGWA NOC for your water extraction activities."
        benefits={cgwaNocBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Water Conservation and Extraction Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple CGWA NOC Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="CGWA NOC Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
